import React from 'react';
import PropTypes from 'prop-types';
import { Icon, Link as ANFLink } from 'anf-core-react';

/**
 * MapLink Component
 * 
 * Renders a map link for carrier drop-off locations when enabled
 * 
 * @param {Object} props - Component props
 * @param {Object} props.carrier - Carrier information
 * @returns {JSX.Element|null} The map link component or null if not applicable
 */
export default function MapLink({ carrier }) {
  if (!carrier?.showMapLinkOnConfirmation) {
    return null;
  }

  const carrierMeta = carrier?.children?.find((child) => !!child.showMapLink);
  if (!carrierMeta) {
    return null;
  }

  return (
    <div className="link-wrapper" data-testid={`carrier-${carrier.type}-map-link`}>
      <ANFLink href={carrier.mapUrl} target="_blank">
        {carrierMeta.showMapLink}
      </ANFLink>
      <div className="external-link-icon">
        <Icon
          icon="external-link-anf"
          labelText="external-link-anf"
        />
      </div>
    </div>
  );
}

MapLink.propTypes = {
  carrier: PropTypes.shape({
    type: PropTypes.string,
    showMapLinkOnConfirmation: PropTypes.bool,
    mapUrl: PropTypes.string,
    children: PropTypes.arrayOf(
      PropTypes.shape({
        showMapLink: PropTypes.string,
      })
    ),
  }),
}; 